// Vendor imports
const _ = require('lodash')
const React = require('react')
const ReactDOM = require('react-dom')

class Portal extends React.Component {
  constructor(props) {
    super(props)

    this.state = { hydrated: false }
  }

  componentDidMount() {
    if (typeof document === 'object') {
      this.setState(() => ({ hydrated: true }))
    }
  }

  resolveContainer() {
    const { container } = this.props
    // HTML Selector
    if (_.isString(container)) {
      return document.querySelector(container)
    }
    // Raw HTML Element
    if (container instanceof Element) {
      return container
    }
    // React RefObject containing an HTML Element
    if (_.isObject(container) && container.current instanceof Element) {
      return container.current
    }
    throw new Error(`Unsupported Portal container: ${container}`)
  }

  render() {
    /**
     * Portals are not supported by `ReactDOM.hydrate`
     * @see https://github.com/facebook/react/issues/13097
     */
    if (this.state.hydrated) {
      return ReactDOM.createPortal(
        this.props.children,
        this.resolveContainer()
      )
    }
    return null
  }

  static toModalRoot(...children) {
    return React.createElement(Portal, {
      container: '#modal-root'
    },
      ...children
    )
  }

}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const morePropTypes = require('client-v2/common/utils/prop-types')

  Portal.containerPropType = PropTypes.oneOfType([
    PropTypes.shape({ current: morePropTypes.domElement }),
    morePropTypes.domElement,
    PropTypes.string
  ])

  Portal.propTypes = {
    children: PropTypes.node,
    container: Portal.containerPropType.isRequired
  }
}

module.exports = Portal
